import React from 'react';
import {
  GridFlex,
  GridImage,
  GridInfo,
  GridMobileImage,
  GridRow,
} from './styles';
import {Container} from '../../global';
import {ActionButton, SectionText, SectionTitle} from '../../atoms';
import ReactHtmlParser from 'react-html-parser';

const Grid = ({
  backgroundColor,
  backgroundImage,
  reverse,
  sectionTitle,
  sectionText,
  buttonText,
  navigateTo,
  longTitle,
}) => {
  return (
    <GridRow>
      <Container>
        <GridFlex reverse={reverse}>
          <GridImage backgroundImage={backgroundImage} reverse={reverse} />
          <GridMobileImage src={backgroundImage} />
          <GridInfo>
            <SectionTitle color={backgroundColor} long={longTitle}>
              {sectionTitle}
            </SectionTitle>
            <SectionText margin={'1rem 0 1rem'}>
              {ReactHtmlParser(sectionText)}
            </SectionText>
            <ActionButton color={backgroundColor} to={navigateTo}>
              {buttonText || 'Czytaj dalej'}
            </ActionButton>
          </GridInfo>
        </GridFlex>
      </Container>
    </GridRow>
  );
};

export default Grid;
